export const DEFAULT_PIXEL_SIZE = 16;
/**
 * takes a pixel value (number) and returns a string in rem
 * @example pxToRem(16) => '1rem'
 */
export function pxToRem(px) {
    return `${px / DEFAULT_PIXEL_SIZE}rem`;
}
